const passTrackLogo = require("../../assets/logo-passtrack.png");

const LOGOS: { [key: string]: string } = {
  passTrackLogo,
};

export default LOGOS;
